import Tdg_FeedbackListPagingResultModelBase from '../_generated/modelBases/tdg-feedback-list-paging-result-model-base';

export default class Tdg_FeedbackListPagingResultModel extends Tdg_FeedbackListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
